import React from 'react'
import { Flex, Layout } from 'antd'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getCriticalConfig } from 'src/app/store/masterSetup'
import banner from 'src/assets/images/login-banner.png'
import './index.scss'
import { useWindowSize } from 'src/app/shared/hooks/useWindowSize'

const { Content } = Layout

const outletStyle: React.CSSProperties = {
  paddingTop: '32px',
  paddingInlineStart: '4rem',
  paddingInlineEnd: '4rem',
  overflowY: 'auto',
  lineHeight: '30px',
  width: '100%',
  height: '100%',
  maxHeight: '100vh',
  backgroundColor: '#F8F8F8',
  borderTop: `2px solid #CCCCCC`,
}

const AuthBaseLayout: React.FC<any> = () => {
  const criticalConfig = useSelector(getCriticalConfig)
  const { mode } = useWindowSize()
  const encodeUrl = (url: string) => {
    return url.replaceAll(/ /g, '%20')
  }

  return (
    <div className='auth__layoutContainer'>
      <Layout>
        <Content>
          <Flex style={{ height: '100%' }}>
            {mode === 'desktop' && (
              <div
                style={{
                  backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 1) 15%, rgba(0, 0, 0, 0) 85%), url(${encodeUrl(
                    criticalConfig?.brandingImage.loginBanner ?? banner,
                  )})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  flex: 1,
                  height: '100%',
                  // padding: '60px 40px',
                  position: 'relative',
                }}
              >
                {criticalConfig?.brandingImage.loginBannerHeaderLogo && (
                  <div
                    style={{
                      borderBottomColor: '#fff',
                      borderBottomWidth: 1,
                      borderBottomStyle: 'solid',
                      margin: '40px 0 0 40px',
                      paddingBottom: 24,
                    }}
                  >
                    <img
                      style={{
                        width: '36rem',
                        height: 'auto',
                      }}
                      alt='header_logo'
                      src={criticalConfig.brandingImage.loginBannerHeaderLogo}
                    />
                  </div>
                )}
                {criticalConfig?.brandingImage.loginBannerFooterLogo && (
                  <img
                    style={{
                      width: '18rem',
                      height: 'auto',
                      position: 'absolute',
                      bottom: 46,
                      right: 40,
                    }}
                    alt='header_logo'
                    src={criticalConfig.brandingImage.loginBannerFooterLogo}
                  />
                )}
              </div>
            )}
            <Flex
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
              }}
            >
              <img
                draggable={false}
                style={{
                  width: '18rem',
                  height: 'auto',
                  margin: '4rem 0 4rem 0',
                }}
                alt='bfa_logo_image'
                src={criticalConfig?.brandingImage?.homeLogo}
              />
              <div style={outletStyle}>
                <Outlet />
              </div>
            </Flex>
          </Flex>
        </Content>
      </Layout>
    </div>
  )
}

export default AuthBaseLayout
